<template>
    <van-popup
        v-model="visibleDialog"
        position="bottom"
        @close='onClose'
    >
        <van-picker
            show-toolbar
            title="选择年月"
            :columns="columns"
            :default-index='4'
            @confirm='onConfirm'
            @cancel='onClose'
        />
    </van-popup>
</template>

<script>
export default {
    props: {
        visible2: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            month: [
                { text: '01' },
                { text: '02' },
                { text: '03' },
                { text: '04' },
                { text: '05' },
                { text: '06' },
                { text: '07' },
                { text: '08' },
                { text: '09' },
                { text: '10' },
                { text: '11' },
                { text: '12' }
            ],
            columns: []
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visible2
            },
            set () {
                this.$emit('update:visible2')
            }
        }
    },
    methods: {
        getYearMonth (val) {
            let newYear = new Date().getFullYear()
            let newMoth = new Date().getMonth() + 1
            let yearMoth = this.month.slice(0, newMoth)
            let dateArr = [{ text: '全部', children: [{ text: '' }] }]
            for (let i = 0; i <= newYear - val; i++) {
                dateArr.push({
                    text: String(newYear - i),
                    children: (newYear - i) >= newYear ? yearMoth : this.month
                })
            }
            this.columns = dateArr.reverse()
        },
        onClose () {
            this.$emit('update:visible2')
        },
        onConfirm (value) {
            this.$emit('updateTime', this.formatDateTime(value))
            this.onClose()
        },
        formatDateTime (inputTime) {
            if (inputTime[0] === '全部') {
                return inputTime[0]
            }
            return inputTime[0] + '-' + inputTime[1]
        }
    },
    mounted () {
        this.getYearMonth(2018)
    }
}
</script>

<style lang='scss' scoped>
/deep/ .van-picker__toolbar{
    height: 80px;
    line-height: 80px;
}
/deep/ .van-picker__title{
    font-size: 32px;
    line-height: normal;
}
/deep/ .van-picker__cancel{
    font-size: 28px;
    color: #ff7a45;
}
/deep/ .van-picker__confirm{
    font-size: 28px;
    color: #ff7a45;
}
/deep/ .van-picker-column{
    font-size: 28px;
}
</style>